import { z } from "zod";
import { invoiceStatus } from "@/features/billing/types/billing.types";
import { Triptype } from "@/features/trips/types/trip.types";
import { optionalFilterString } from "@/schemas/filter.schema";

export const billingFiltersSchema = z.object({
	search: optionalFilterString,
	invoiceStatus: z
		.enum([
			invoiceStatus.PENDING,
			invoiceStatus.PAID,
			invoiceStatus.OVERDUE,
			"",
		])
		.optional(),
	tripType: z
		.enum([
			"",
			Triptype.PUBLIC,
			Triptype.BUSINESS,
			Triptype.COMMUTE,
			Triptype.PRIVATE,
		])
		.optional(),
	issuedDate: optionalFilterString,
	dueDate: optionalFilterString,
});
